import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import bookUrl from "../../../../api/bookUrl";
interface Props {
  aboutContent: string;
  onAboutChange: (content: string) => void;
}

export const AboutUs: React.FC<Props> = ({ aboutContent, onAboutChange }) => {
  const [content, setContent] = useState(aboutContent);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"],
    ],
  };

  const handleSave = () => {
    onAboutChange(content);
    bookUrl
      .patch("/bookingclinic/clinic/updateBookClinic", {
        about: content,
      })
      .then((response) => {
        console.log(response);
      })
      .catch(console.error)
      .finally(() => {
        alert("About Us Saved!");
      });
  };

  return (
    <section className="page-section about-us">
      <div className="section-header">
        <h2>About Us</h2>
        <button className="btn btn-primary" onClick={handleSave}>
          <SaveAltIcon /> Save
        </button>
      </div>

      <ReactQuill
        theme="snow"
        value={content}
        onChange={setContent}
        modules={modules}
      />
    </section>
  );
};
